<template>
  <div class="phone-code">
    <el-input v-model="code"
              class="inputIcon"
              prefix-icon="el-icon-message"
              :suffix-icon="checkFlag && code.length>=4? '' : 'el-icon-warning'"
              autocomplete="off"
              auto-complete="off"
              placeholder="手机验证码"
              style="width: 246px"/>
    <el-button style="margin-left: 10px"
               :disabled="!checkFlag"
               v-if="buttonStatus === 0"
               @click="getCode">获取验证码</el-button>
    <SetTime class="el-button"
             v-if="buttonStatus === 1"
             @over="buttonStatus = 2"/>
    <el-button style="margin-left: 10px"
               v-if="buttonStatus === 2"
               @click="getCode">重新获取</el-button>
  </div>
</template>

<script>
  import apis from "@/api/apis";
  import SetTime from './time'

  export default {
    name: "VerificationCode",
    components: { SetTime },
    props:{
      mobile: String,
      type: {
        type: String,
        default: 'register'
      },
      anotherSendApi:{
        type:String,
        default:null
      },
      checkFlag: Boolean // 按钮是否可以点击
    },
    data(){
      return {
        code: '',
        buttonStatus: 0, // 获取验证码状态
        timeHandle: null
      }
    },
    methods: {
      // 短信验证码
      getCode(){
        if (this.anotherSendApi==='offsiteLogin') {
          apis.login.offsiteCode({mobile: this.mobile, event: this.type}).then(res => {
            this.$notify({
              title: '通知',
              message: res.msg
            })
            this.buttonStatus = 1
          })
        } else {
          apis.login.send({mobile: this.mobile, event: this.type}).then(res => {
            this.$notify({
              title: '通知',
              message: res.msg
            })
            this.buttonStatus = 1
          })
        }
      }
    },
    watch:{
      code(value) {
        this.$emit('input', value)
      }
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep.inputIcon .el-input__suffix{
    color: red;
  }
  .phone-code{
    display: flex;
    align-items: center;
    .el-button{
      width: 110px;
      height: 40px;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>